import { v4 as uuidv4 } from 'uuid';
import snakeCase from 'lodash/snakeCase';
import Fingerprint2 from 'fingerprintjs2';

const LOGIN_HASH = (entity: string) => `${entity}_login_hash`;

const options = {
  excludes: {
    adBlock: true,
    enumerateDevices: true,
    pixelRatio: true,
    doNotTrack: true,
    fontsFlash: true
  }
};

const parseFingerPrint = (data: any) => {
  const fingerPrintData: Record<string, string> = {};
  data.forEach((fingerprint: any) => {
    fingerPrintData[snakeCase(fingerprint.key)] = fingerprint.value;
  });
  return fingerPrintData;
};

const browserFingerprint = new Promise<{
  hash: string;
  data: Record<string, string>;
}>(resolve => {
  Fingerprint2.get(options, components => {
    // exclude some components when generating hash
    // "screenResolution", "availableScreenResolution" key, different hash in firefox browser
    const excludesComponentsForHash = [
      'screenResolution',
      'availableScreenResolution'
    ];

    const componentsToHash = components.filter(e => {
      return !excludesComponentsForHash.includes(e.key);
    });

    const fingerprintHash = Fingerprint2.x64hash128(
      componentsToHash
        .map(pair => {
          return pair.value;
        })
        .join(),
      31
    );

    resolve({
      hash: fingerprintHash as string,
      data: parseFingerPrint(components) as Record<string, string>
    });
  });
});

const isHashedCookie = (cname: string) => {
  const name = cname + '=';
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(';');
  for (let c of ca) {
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return false;
};

const getCanvasData = (entity: string) => {
  const cname = LOGIN_HASH(entity);
  const isThisBrowserHashed = isHashedCookie(cname);
  if (!isThisBrowserHashed) {
    const cvalue = uuidv4();
    const d = new Date();
    d.setTime(d.getTime() + 365 * 24 * 60 * 60 * 1000);
    const expires = 'expires=' + d.toUTCString();
    document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
    return cvalue;
  }

  return isThisBrowserHashed;
};

export const getFingerprintData = async (entity: string) => {
  const canvasHash = getCanvasData(entity);
  const fingerprint = await browserFingerprint;
  return {
    fingerprintHash: fingerprint.hash,
    fingerprintData: fingerprint.data,
    canvasHash
  };
};
